import styles from "../styles/variable.module.scss";

const { colorPrimary, colorSecondary, colorTextBase, colorTextHeading, colorTextPlaceholder } = styles;

export const colors = {
  colorPrimary,
  colorSecondary,
  colorTextBase,
  colorSuccess: styles.colorPrimary,
  colorTextPlaceholder,
  colorTextHeading
};
export const text = {
  fontFamily: "Poppins, sans-serif",
  fontSizeHeading1: 22,
  fontSizeHeading2: 20,
  fontSizeHeading3: 18,
  fontSizeHeading4: 16,
  fontSizeText: 14,
  fontWeightStrong: 400
};
